import { DialogClose } from '@radix-ui/react-dialog'
import { useState, VFC } from 'react'
import { getBackboneWindow } from '@opallabs/brown-dwarf'
import { Button, Modal } from '@opallabs/lapidary'

type ObjectMissingModalProps = {
  objectName: string
  onEscape?: () => void
}

export const ObjectMissingModal: VFC<ObjectMissingModalProps> = ({
  objectName,
  onEscape,
}) => {
  const [open, setOpen] = useState(true)
  const backboneWindow = getBackboneWindow()
  const redirectPath = `/moments/${backboneWindow.OpalMoments.State?.current_brand_slug}`
  const allowEscape = typeof onEscape === 'function'

  const handleOpenChange = () => {
    if (allowEscape) {
      setOpen(false)
      onEscape()
    }
  }

  return (
    <Modal.Root open={open} onOpenChange={handleOpenChange}>
      <Modal.Content className="object-missing-error-modal">
        <Modal.Title>This {objectName} cannot be loaded.</Modal.Title>
        {allowEscape ? <Modal.Close /> : null}
        <Modal.Body>
          <Modal.Description>
            This {objectName} could not be found, you do not have access, or
            your browser needs to be refreshed.
          </Modal.Description>
        </Modal.Body>
        <Modal.Footer>
          {allowEscape ? (
            <DialogClose asChild>
              <Button buttonText="Return" name="Return" variant="primary" />
            </DialogClose>
          ) : (
            <Button
              buttonText="Back to Calendar"
              name="Refresh"
              variant="primary"
              onClick={() =>
                (window.top ?? window).location.assign(redirectPath)
              }
            />
          )}
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  )
}
